/**
 * @generated SignedSource<<ffc9561270870d3f3e12993b0f63346f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSteps_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryStep_buyer" | "CheckoutNavigation_buyer" | "CheckoutPaymentStepSelector_buyer" | "CheckoutPaymentStep_buyer" | "CheckoutProgressReview_buyer" | "CheckoutReviewStep_buyer" | "CheckoutShippingStep_buyer">;
  readonly " $fragmentType": "CheckoutSteps_buyer";
};
export type CheckoutSteps_buyer$key = {
  readonly " $data"?: CheckoutSteps_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSteps_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSteps_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutShippingStep_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDeliveryStep_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutReviewStep_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutNavigation_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutProgressReview_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutPaymentStep_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutPaymentStepSelector_buyer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "34450064252eb6640e1696d873fdd748";

export default node;
